import * as React from 'react';
import { observer } from 'mobx-react';
import { FormState, FieldState } from 'formstate';

// Utilities
import { required, between } from '../../utilities/validation';

// FormState
class PasswordFormState {

    oldPassword = new FieldState('').disableAutoValidation().validators(required, between(4, 32));
    password = new FieldState('').disableAutoValidation().validators(required, between(4, 32));

    state = new FormState({
        oldPassword: this.oldPassword,
        password: this.password
    });

    gerValues() {
        return {
            oldPassword: this.oldPassword.$,
            password: this.password.$
        };
    }

    reset() {
        this.oldPassword.reinitValue('');
        this.password.reinitValue('');
    }
}

// Components
import Box from '../../components/Box';
import Button from '../../components/Button';
import { Form, TextField } from '../../components/FormStateFields';

// Component
interface IProps {
    onSubmit: (values: { oldPassword: string, password: string }) => void;
}
class PasswordTab extends React.Component<IProps, {}> {

    form = new PasswordFormState();

    handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const validation = await this.form.state.validate();

        if (validation.hasError === false) {
            this.props.onSubmit(this.form.gerValues());
            this.form.reset();
        }
    }

    render() {
        return (
            <Form onSubmit={this.handleSubmit}>
                <Box pa={4}>
                    <TextField
                        label="Current Password"
                        type="password"
                        required={true}
                        fieldState={this.form.oldPassword}
                        margin="normal"
                        fullWidth={true}
                    />
                    <TextField
                        label="New Password"
                        type="password"
                        required={true}
                        fieldState={this.form.password}
                        margin="normal"
                        fullWidth={true}
                    />
                    <br />
                    <br />
                    <Button raised={true} color="primary" style={{ width: '100%' }} type="submit">
                        Save
                    </Button>
                </Box>
            </Form>
        );
    }
}

export default observer(PasswordTab);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/App/MeDialogPassword.tsx